<div [formGroup]="form" class="grid align-items-center">
  <div class="col-12 md:col-3">
    <tj-field label="Admins">
      <tj-admin-combobox
        formControlName="id"
      ></tj-admin-combobox>
    </tj-field>
  </div>

  <div class="col-12 md:col-3">
    <tj-field label="Name">
      <input
        id="firstName"
        type="text"
        pInputText
        formControlName="firstName"
        placeholder="Enter name"
      />
    </tj-field>
  </div>

  <div class="col-12 md:col-3">
    <tj-field label="Surname">
      <input
        id="lastName"
        type="text"
        pInputText
        formControlName="lastName"
        placeholder="Enter surname"
      />
    </tj-field>
  </div>

  <div class="col-12 md:col-3">
    <tj-field label="Email">
      <input
        id="email"
        type="email"
        pInputText
        formControlName="email"
        placeholder="Enter email"
      />
    </tj-field>
  </div>

</div>
